<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">
			<img src="../../assets/img/q1.png" style="width:96px;height:48px;margin-top:13px;"/>
		</div>
        <div class="header-right">
            <div class="header-user-con">
				<div class="btn-bell" v-if="controll['pdf-editor']">
					<router-link to="/pdf-editor" style="color:white" v-if="controll['pdf-editor']">
						<el-tooltip effect="dark" content="PDF编辑器" placement="bottom">
						<i class="el-icon-s-operation"></i></el-tooltip>
					</router-link>
                </div>
				<div class="btn-bell" v-if="controll['chess-qzone']">
					<el-badge :value="unReadQzoneSize" v-if="unReadQzoneSize>0 && controll['chess-qzone']">
						<router-link to="/chess-qzone" style="color:white"><el-tooltip effect="dark" content="关注动态" placement="bottom"><i class="el-icon-star-off"></i></el-tooltip></router-link>
					</el-badge>
					<router-link to="/chess-qzone" style="color:white" v-if = "unReadQzoneSize==0 && controll['chess-qzone']"><el-tooltip effect="dark" content="关注动态" placement="bottom"><i class="el-icon-star-off"></i></el-tooltip></router-link>
                </div>
				<div class="btn-bell" v-if="controll['message']">
					<el-badge :value="unReadMessageSize" v-if="unReadMessageSize>0 && controll['message']">
						<div @click="messageDrawerOpen"><el-tooltip effect="dark" content="消息" placement="bottom"><i class="el-icon-bell"></i></el-tooltip></div>
					</el-badge>
					<div @click="messageDrawerOpen" v-if="unReadMessageSize==0 && controll['message']"><el-tooltip effect="dark" content="消息" placement="bottom">
					<i class="el-icon-bell"></i></el-tooltip></div>
                </div>
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>
                <div class="user-avator">
                    <img src="../../assets/img/img.jpg" class="user-avator-img" v-if="myPortrait==''"/>
					<el-image :src="myPortrait" v-if="myPortrait!=''" class="user-avator-img"/>
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{name}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
						<router-link to="/my-company" v-if = "controll['my-company']"><el-dropdown-item divided command="updateInfo">我的企业</el-dropdown-item></router-link>
						<router-link to="/personal" v-if = "controll['personal']"><el-dropdown-item divided command="updateInfo">个人信息</el-dropdown-item></router-link>
						<router-link to="/my-achievement" v-if = "controll['my-achievement']"><el-dropdown-item divided command="myAchievement">我的业绩</el-dropdown-item></router-link>
						<router-link to="/my-todo-list" v-if = "controll['my-todo-list']"><el-dropdown-item divided command="todoList">待办事项</el-dropdown-item></router-link>
						<router-link to="/reset" v-if = "controll['reset']"><el-dropdown-item divided command="resetPassword">修改密码</el-dropdown-item></router-link>
                        <el-dropdown-item divided command="userLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
import { getControll } from '../../utils/controlls';
import bus from '../common/bus';
import { logout } from '../../api/index';
import { closeSocket } from '../../utils/websocket'
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            name: '未知',
            message: 2,
			myPortrait:"",
			imgPrefix:"/image",
			unReadQzoneSize:0,
			unReadMessageSize:0,
			unReadMessageMap:{},
			controll:{}
        };
    },
	created() {
		this.controll = getControll("header");
		this.initUser();
		bus.$on('unReadQzoneSize', msg => {
            this.unReadQzoneSize = msg;
        });
		bus.$on('unReadMessageSize', msg => {
			for (let i = 0; i < msg.length; i++) {
				this.unReadMessageSize += msg[i].num;
			}
			this.unReadMessageMap = msg;
		});
		bus.$on('unReadMessageSizeUpdate', msg => {
			this.unReadMessageSize += msg;
			//for (let i = 0; i < this.unReadMessageMap.length; i++) {
			//	if (this.unReadMessageMap[i].messageType == msg) {
			//		this.unReadMessageMap[i].num -= 1;
			//	}
			//}
		});
    },
    methods: {
		initUser() {
			let username = localStorage.getItem('ms_currentUserName');
            if (username){
			   this.name = username;
			}
			let userProtrait = localStorage.getItem('ms_currentPortrait');
			if (userProtrait != "null"){
				this.myPortrait = this.imgPrefix + userProtrait;
			}
		},
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'userLogout') {
				logout()
				.then(res => {
					if (res.code == 0) {
						localStorage.removeItem('ms_token');
						localStorage.removeItem('ms_ukey');
						localStorage.removeItem('ms_dkey');
						localStorage.removeItem('ms_ckey');
						localStorage.removeItem('ms_currentUserName');
						localStorage.removeItem("ms_menus");
						localStorage.removeItem("ms_controlls");
						localStorage.removeItem('ms_currentPortrait');
						localStorage.removeItem('ms_currentRoleName');
						localStorage.removeItem('ms_currentLastLoginTime');	
						closeSocket();
						bus.$emit("message-notify-close", "");
						this.$router.push('/login');
					} else {
						this.$message.error(res.message);
						return false;
					}
				});
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
		getContorlls() {
			let controlls = eval('(' +localStorage.getItem('ms_controlls') + ')');
			let current = controlls[this.index];
			if (current) {
				this.controll = current;
			}
		},
		messageDrawerOpen() {
			bus.$emit('message-drawer-open', this.unReadMessageMap);
		}
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 70px;
}
.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 20px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
	margin-right: 20px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 20px;
}
.user-avator-img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
</style>
